import React, { useState, useEffect } from "react";
import styles from "./css/index.module.css";

import programset, { initialProgramSchedule } from "./data/programs";

import Modal from "../../components/modal";

const Program = () => {
    useEffect(() => {
        setPrograms(initialProgramSchedule);
    }, []);

    const [programs, setPrograms] = useState();

    const [selectedDate, setSelectedDate] = useState("Select Date");
    const [modalContent, setModalContent] = useState({
        title: "",
        state: false,
        bodyContent: "",
    });

    const filterProgram = async (date) => {
        setSelectedDate(date);

        const programTobeFiltered = JSON.parse(JSON.stringify(programset));

        const filteredPrograms = await programTobeFiltered.filter((program) => program.day === date);
        if (filteredPrograms.length == 0) {
            setPrograms(initialProgramSchedule);
            return;
        }
        setPrograms(filteredPrograms);

        console.log(filteredPrograms, "Filtered Programs");
    };

    const handleStateChange = (state) => {
        setModalContent({
            title: "",
            state: false,
            bodyContent: "",
        });
    };

    return (
        <section className={styles.containerWrapper}>
            <div className={styles.heroSection}>
                <div className={styles.containerTitle}>CCETC 2024 PROGRAMME </div>
                <div className={styles.containerSubTitle}>
                    C3iHub’s Conference on Emerging Trends in <span>Cybersecurity</span>
                </div>

                <div className={styles.containerRegistrationContainer}>{/* <div className={styles.containerRegistrationButton}>Register Now</div> */}</div>
            </div>

            {/* <div className={styles.containerSearchContent}>
        <div className={styles.containerSearchContentHeader}>
          <div className={styles.containerSearchContentHeaderTabs}>22nd October 2024</div>
          <div className={styles.containerSearchContentHeaderTabs}>23rd October 2024</div>
        </div>
        <div className={styles.containerSearchContentBody}>
          
          <div className={styles.containerSearchContentBodyItem}><select className={styles.containerSearchContentDropdown}>
            <option>Theme</option>
            <option>Option 2</option>
            <option>Option 3</option>
          </select></div>
          <div className={styles.containerSearchContentBodyItem}><select className={styles.containerSearchContentDropdown}>
            <option>Venue</option>
            <option>Option 2</option>
            <option>Option 3</option>
          </select></div>
        </div>
        
      </div> */}

            <div className={styles.containerBody}>
                {/* <div className={styles.containerSearchContentBodyItem}>
                    <select value={selectedDate} className={styles.containerSearchContentDropdown} onChange={(e) => filterProgram(e?.target?.value)}>
                        <option value="Select Date">Select Date</option>
                        <option value="22nd October 2024">22nd October 2024</option>
                        <option value="23rd October 2024">23rd October 2024</option>
                        <option value="24th October 2024">24th October 2024</option>
                        <option value="25th October 2024">25th October 2024</option>
                    </select>
                    <div value={selectedDate} className={styles.containerSearchContentDropdown}>
                        Download Schedule
                    </div>
                </div> */}

                <div className={styles.containerSearchResults}>
                    {programs?.map((program, index) => {
                        return (
                            <div className={styles.containerSearchResult} key={index}>
                                <div className={styles.resultDuration}>
                                    {program?.time}
                                    <div className={styles.resultDate}>{program?.day}</div>
                                </div>
                                <div className={styles.resultInfo}>
                                    <div className={styles.resultInfoWrapper}>
                                        <div className={styles.resultInfoTitle}>
                                            {typeof program.event === "string" ? (
                                                program.event
                                            ) : (
                                                <ul>
                                                    {program.event.map((item) => (
                                                        <li>{item}</li>
                                                    ))}
                                                </ul>
                                            )}
                                        </div>
                                    </div>
                                    <div className={styles.resultMoreInfo}>
                                        {/* <button
                                                className={styles.moreInfoButton}
                                                onClick={() => {
                                                    const payload = {
                                                        state: true,
                                                        title: program?.event,
                                                        bodyContent: program?.venue,
                                                    };
                                                    console.log(payload, "PAYLOAD");
                                                    setModalContent(payload);
                                                }}
                                            >
                                                More info
                                            </button> */}
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>

            <Modal state={modalContent?.state} title={modalContent?.title} bodyContent={modalContent?.bodyContent} setState={handleStateChange} />
        </section>
    );
};

export default Program;
